import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { paths } from '@platform/paths';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { HasCompanyClientUiSettingsDisabledDirective } from '@shared/directives/has-company-client-ui-settings-disabled.directive';
import { HasCompanyClientUiSettingsEnabledDirective } from '@shared/directives/has-company-client-ui-settings-enabled.directive';
import { CompanyClientUISettingsKey } from '@shared/services/company-client-ui-settings.service';
import { selectAdviserContactDetails } from '@shared/store/adviser/adviser.selectors';
import { selectClientUser } from '@shared/store/client-user/client-user.selectors';
import { selectIsExperianCompany } from '@shared/store/common.selectors';
import { selectCompanyLogo } from '@shared/store/company/company.selectors';
import { ButtonDirective } from 'primeng/button';
import { NavigationItemComponent } from '../navigation-item/navigation-item.component';

@Component({
  selector: 'cp-side-panel-navigation',
  imports: [
    CommonModule,
    NavigationItemComponent,
    RouterLink,
    IconComponent,
    ButtonDirective,
    HasCompanyClientUiSettingsEnabledDirective,
    HasCompanyClientUiSettingsDisabledDirective,
  ],
  templateUrl: './side-panel-navigation.component.html',
  styleUrl: './side-panel-navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidePanelNavigationComponent {
  protected readonly globalStore = inject(Store);
  protected readonly paths = paths;

  protected readonly companyLogo$ = this.globalStore.select(selectCompanyLogo);
  protected readonly adviserContactDetails$ = this.globalStore.select(selectAdviserContactDetails);
  protected readonly user$ = this.globalStore.select(selectClientUser);
  protected readonly isExperianCompany$ = this.globalStore.select(selectIsExperianCompany);

  protected readonly showDocumentUploadKey: CompanyClientUISettingsKey = 'showDocument';
  protected readonly showAdvisorPageKey: CompanyClientUISettingsKey = 'showAdvisorPage';
  protected readonly showProfilePageKey: CompanyClientUISettingsKey = 'showProfilePage';
}
